module.exports = __webpack_public_path__ + "img/Fernando_Herrera.45669624.jpg";